<template>
  <v-layout row wrap fluid class="d-flex mx-auto">
    <v-flex xs12 pa-5>
      <p class="title primary--text font-weight-medium">ตั้งค่า</p>
      <v-divider></v-divider>
    </v-flex>
    <v-flex xs12 pa-5 pt-0>
      <div>
        <v-tabs grow hide-slider>
          <v-tab href="#tabAdmin" v-if="userLoginRole === 'ADMIN'" @click="searchType = 'tabAdmin'"
            >จัดการผู้ใช้</v-tab
          >
          <!-- <v-tab
            href="#tabCitizen"
            @click="searchType='tabCitizen'"
          >
            ประชาชน
          </v-tab>-->
          <v-tab
            href="#tabFestival"
            v-if="userLoginRole === 'ADMIN'"
            @click="serchType = 'tabFestival'"
            >เทศกาล</v-tab
          >
          <v-tab href="#tabTrainSetting" @click="serchType = 'tabTrainSetting'">ขบวนรถไฟ</v-tab>
          <v-tab-item value="tabAdmin" class="px-5 pt-5">
            <v-layout row wrap ma-0>
              <v-data-table
                style="width: 100%;"
                :headers="userHeader"
                :items="userItems"
                :items-per-page="10"
                :footer-props="footerProps"
                loading-text="กำลังโหลดข้อมูล"
                no-data-text="ไม่พบข้อมูล"
                class="elevation-0 mt-2"
                :hide-default-footer="userItems.length == 0"
                :mobile-breakpoint="0"
              >
                <template v-slot:item="props">
                  <tr :class="{ 'inactive-user': !props.item.enabled }">
                    <td>
                      {{
                        userItems
                          .map(function(x) {
                            return x.id;
                          })
                          .indexOf(props.item.id) + 1
                      }}
                    </td>
                    <td>{{ props.item.username }}</td>
                    <td>{{ props.item.email }}</td>
                    <!-- <td>
                      <v-checkbox
                        readonly
                        v-model="props.item.enabled"
                        class="mt-0 mx-2 pt-0 cb-enable"
                        color="primary"
                      > </v-checkbox>
                    </td>-->
                    <td>{{ props.item.role }}</td>
                    <td>{{ props.item.lastLogin }}</td>
                    <td>
                      <v-btn
                        rounded
                        outlined
                        color="primary"
                        min-width="120px"
                        v-on="on"
                        @click.stop="$set(dialogEditUser, props.item.id, true)"
                        >แก้ไข</v-btn
                      >

                      <v-dialog
                        v-model="dialogEditUser[props.item.id]"
                        min-width="320px"
                        max-width="480px"
                      >
                        <!-- dialog -->
                        <v-card>
                          <v-card-title class="v-card-title">
                            <span class="subtitle-1">แก้ไขผู้ใช้ {{ props.item.username }}</span>
                            <v-icon
                              color="#BA4438"
                              @click.stop="$set(dialogEditUser, props.item.id, false)"
                              >close</v-icon
                            >
                          </v-card-title>
                          <v-form ref="formUpdate" v-model="valid" lazy-validation>
                            <v-card-text>
                              <v-container>
                                <v-layout v-show="false" row wrap ma-4 mt-0>
                                  <v-flex>
                                    <p class="font-weight-bold mb-0">ชื่อผู้ใช้</p>
                                    <v-text-field
                                      label="พิมพ์ชื่อผู้ใช้"
                                      flat
                                      solo
                                      readonly
                                      v-model="props.item.username"
                                      :rules="usernameRules"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap ma-4 mt-0>
                                  <v-flex>
                                    <p class="font-weight-bold mb-0">ชื่อและนามสกุล</p>
                                    <v-text-field
                                      label="พิมพ์ชื่อและนามสกุล"
                                      single-line
                                      v-model="props.item.fullname"
                                      class="pt-1"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap ma-4 mt-0>
                                  <v-flex>
                                    <p class="font-weight-bold mb-0">อีเมล</p>
                                    <v-text-field
                                      label="พิมพ์อีเมล"
                                      single-line
                                      v-model="props.item.email"
                                      :rules="emailRules"
                                      class="pt-1"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap ma-4 mt-0>
                                  <v-flex>
                                    <p class="font-weight-bold mb-0">รหัสผ่าน</p>
                                    <v-text-field
                                      label="พิมพ์รหัสผ่าน"
                                      single-line
                                      type="password"
                                      v-model="props.item.password"
                                      class="pt-1"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap ma-4 mt-0>
                                  <v-flex>
                                    <p class="font-weight-bold mb-0">ยืนยันรหัสผ่าน</p>
                                    <v-text-field
                                      label="พิมพ์ยืนยันรหัสผ่าน"
                                      single-line
                                      type="password"
                                      v-model="props.item.confirm_password"
                                      :rules="[confirmPasswordRules.check(props.item.password, props.item.confirm_password)]"
                                      class="pt-1"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap ma-4 mt-0>
                                  <v-flex>
                                    <p class="font-weight-bold mb-0">สิทธิ์ผู้ใช้งาน</p>
                                    <v-select
                                      v-model="props.item.role_code"
                                      :items="roleItems"
                                      item-text="name_th"
                                      item-value="code"
                                      label="เลือก"
                                      no-data-text="ไม่พบข้อมูล"
                                      single-line
                                    ></v-select>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap ma-4 mt-0 mb-0>
                                  <v-flex row>
                                    <v-checkbox
                                      class="mt-0 mx-2 pt-0 cb-enable"
                                      color="primary"
                                      v-model="props.item.enabled"
                                    ></v-checkbox>
                                    <p class="font-weight-bold mb-0">เปิดใช้งาน</p>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-card-actions class="mr-7 pb-5 pt-0">
                              <div class="flex-grow-1"></div>
                              <v-btn
                                rounded
                                color="primary"
                                min-width="120px"
                                v-on="on"
                                @click="openConfirmDialog(props.item.id)"
                                >ลบ</v-btn
                              >
                              <v-btn
                                rounded
                                color="primary"
                                min-width="120px"
                                v-on="on"
                                class="ml-2"
                                @click="submitUpdate(props.item)"
                                >บันทึก</v-btn
                              >
                            </v-card-actions>
                          </v-form>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="confirmDialog[props.item.id]" width="400" persistent>
                        <v-card class="pt-2">
                          <v-card-text class="subtitle-1 black--text mb-2"
                            >ผู้ใช้ที่เลือกจะถูกลบอย่างถาวร ต้องการดำเนินการต่อใช่หรือไม่
                            ?</v-card-text
                          >
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="cancelDeleteUser">ยกเลิก</v-btn>
                            <v-btn color="primary" @click="confirmDeleteUser(props.item.username)"
                              >ดำเนินการต่อ</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </td>
                  </tr>
                </template>
                <template v-slot:footer.page-text="props"
                  >{{ props.pageStart }} - {{ props.pageStop }} จาก
                  {{ props.itemsLength }}</template
                >
              </v-data-table>

              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                rounded
                width="120"
                color="primary"
                class="mt-2 ml-2"
                @click.stop="dialogAddUser = true"
                >เพิ่ม</v-btn
              >

              <v-dialog v-model="dialogAddUser" min-width="320px" max-width="480px">
                <!-- dialog -->
                <v-card>
                  <v-card-title class="v-card-title">
                    <span class="subtitle-1">เพิ่มผู้ใช้</span>
                    <v-icon color="#BA4438" @click.stop="dialogAddUser = false">close</v-icon>
                  </v-card-title>
                  <v-form ref="formRegister" v-model="valid" lazy-validation>
                    <v-card-text>
                      <v-container>
                        <v-layout row wrap ma-4 mt-0>
                          <v-flex>
                            <p class="font-weight-bold mb-0">อีเมล</p>
                            <v-text-field
                              class="pt-1"
                              label="พิมพ์อีเมล"
                              single-line
                              v-model="userAdd.email"
                              :rules="emailRules"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row wrap ma-4 mt-4>
                          <v-flex>
                            <p class="font-weight-bold mb-0">ชื่อผู้ใช้</p>
                            <v-text-field
                              class="pt-1"
                              label="พิมพ์ชื่อผู้ใช้"
                              single-line
                              v-model="userAdd.username"
                              :rules="usernameRules"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row wrap ma-4 mt-4>
                          <v-flex>
                            <p class="font-weight-bold mb-0">ชื่อและนามสกุล</p>
                            <v-text-field
                              class="pt-1"
                              label="พิมพ์ชื่อและนามสกุล"
                              single-line
                              v-model="userAdd.fullname"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row wrap ma-4 mt-4>
                          <v-flex>
                            <p class="font-weight-bold mb-0">รหัสผ่าน</p>
                            <v-text-field
                              class="pt-1"
                              label="พิมพ์รหัสผ่าน"
                              single-line
                              type="password"
                              v-model="userAdd.password"
                              :rules="passwordRules"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row wrap ma-4 mt-4>
                          <v-flex>
                            <p class="font-weight-bold mb-0">ยืนยันรหัสผ่าน</p>
                            <v-text-field
                              class="pt-1"
                              label="พิมพ์ยืนยันรหัสผ่าน"
                              single-line
                              type="password"
                              v-model="userAdd.confirm_password"
                              :rules="[confirmPasswordRules.check(userAdd.password, userAdd.confirm_password)]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout row wrap ma-4 mt-4>
                          <v-flex>
                            <p class="font-weight-bold mb-0">สิทธิ์ผู้ใช้งาน</p>
                            <v-select
                              v-model="userAdd.role"
                              :items="roleItems"
                              item-text="name_th"
                              item-value="code"
                              label="เลือก"
                              no-data-text="ไม่พบข้อมูล"
                              single-line
                              :rules="roleRules"
                            ></v-select>
                          </v-flex>
                        </v-layout>

                        <!-- <v-layout
                          row
                          wrap
                          ma-4
                          mt-8
                          mb-0
                        >
                          <v-flex row>
                            <v-checkbox
                              class="mt-0 mx-2 pt-0 cb-enable"
                              color="primary"
                              v-model="userAdd.enabled"
                            > </v-checkbox>
                            <p class="font-weight-bold mb-0"> Enabled </p>
                          </v-flex>
                        </v-layout>-->
                      </v-container>
                    </v-card-text>

                    <v-card-actions class="mr-2 pb-5 pt-3">
                      <div class="flex-grow-1"></div>
                      <v-btn
                        rounded
                        color="primary"
                        min-width="120px"
                        v-on="on"
                        class="ml-2 mr-5"
                        @click="submitRegister"
                        >บันทึก</v-btn
                      >
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-layout>
          </v-tab-item>
          <v-tab-item value="tabFestival" class="px-5 pt-5">
            <v-row>
              <v-col>
                <v-data-table
                  style="width: 100%"
                  :items-per-page="10"
                  loading-text="กำลังโหลดข้อมูล"
                  no-data-text="ไม่พบข้อมูล"
                  :items="festivalitem"
                  :landscape="true"
                  :headers="festivalheader"
                  @update:sort-by="updateRadio()"
                  @update:sort-desc="updateRadio()"
                >
                  <template v-slot:item="props">
                    <tr>
                      <!-- <td>{{props.item.id}}</td> -->
                      <td>
                        <v-row class="justify-center">
                          <!-- <v-checkbox
                            v-model="festivalSelected"
                            color="primary"
                            :value="props.item.id"
                            @change="setFesDefault(props.item)"
                          ></v-checkbox> -->
                          <v-radio-group v-model="festivalSelected" :mandatory="false">
                            <v-radio
                              :value="props.item.id"
                              @change="setFesDefault(props.item)"
                            ></v-radio>
                          </v-radio-group>
                        </v-row>
                      </td>
                      <td>{{ props.item.name }}</td>
                      <td>{{ utils.formatToDateThai(props.item.start_date) }}</td>
                      <td>{{ utils.formatToDateThai(props.item.end_date) }}</td>
                      <td>
                        <v-btn
                          rounded
                          outlined
                          color="primary"
                          min-width="120px"
                          v-on="on"
                          @click.stop="$set(dialogEditFes, props.item.id, true)"
                          >แก้ไข</v-btn
                        >
                        <v-dialog
                          v-model="dialogEditFes[props.item.id]"
                          min-width="320px"
                          max-width="480px"
                        >
                          <!-- dialog -->
                          <v-card>
                            <v-card-title class="v-card-title">
                              <span class="subtitle-1">แก้ไขเทศกาล {{ props.item.name }}</span>
                              <v-icon
                                color="#BA4438"
                                @click.stop="$set(dialogEditFes, props.item.id, false)"
                                >close</v-icon
                              >
                            </v-card-title>
                            <v-form ref="formFesUpdate" v-model="valid" lazy-validation>
                              <v-card-text>
                                <v-container>
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <p class="font-weight-bold mb-0">ชื่อเทศกาล</p>
                                      <v-text-field
                                        label="ชื่อเทศกาล"
                                        flat
                                        solo
                                        v-model="props.item.name"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <DatePicker
                                        ref="editFesStartDate"
                                        v-model="props.item.start_date"
                                        :defaultDate="props.item.start_date"
                                        @input="
                                          changeDate(
                                            utils.startDateChanged(
                                              props.item.start_date,
                                              props.item.end_date
                                            ),
                                            props.item.id
                                          )
                                        "
                                      />
                                    </v-col>
                                    <v-col>
                                      <DatePicker
                                        ref="editFesEndDate"
                                        v-model="props.item.end_date"
                                        :defaultDate="props.item.end_date"
                                        @input="
                                          changeDate(
                                            utils.endDateChanged(
                                              props.item.start_date,
                                              props.item.end_date
                                            ),
                                            props.item.id
                                          )
                                        "
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <p class="font-weight-bold mb-0">เทศกาลเปรียบเทียบ</p>
                                      <v-select
                                        v-model="props.item.compare_id"
                                        :items="
                                          [{ id: '', name: 'ไม่ได้เลือก' }].concat(festivalitem)
                                        "
                                        item-text="name"
                                        item-value="id"
                                        no-data-text="ไม่ได้เลือก"
                                      ></v-select>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                              <v-card-actions class="pa-5">
                                <div class="flex-grow-1"></div>
                                <v-btn
                                  rounded
                                  color="primary"
                                  min-width="120px"
                                  v-on="on"
                                  class="ml-2"
                                  @click="
                                    updateFes(props.item);
                                    $set(dialogEditFes, props.item.id, false);
                                  "
                                  >บันทึก</v-btn
                                >
                              </v-card-actions>
                            </v-form>
                          </v-card>
                        </v-dialog>
                      </td>
                      <td>
                        <v-btn
                          rounded
                          outlined
                          color="primary"
                          min-width="120px"
                          v-on="on"
                          @click="
                            fesdeletealertdialog = true;
                            festarget = props.item;
                          "
                          >ลบ</v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-btn
                  :block="$vuetify.breakpoint.xsOnly"
                  rounded
                  width="120"
                  color="primary"
                  class="mt-2 ml-2"
                  @click.stop="dialogAddFes = true"
                  >เพิ่ม</v-btn
                >
                <v-dialog v-model="dialogAddFes" min-width="320px" max-width="480px">
                  <v-card>
                    <v-card-title class="v-card-title">
                      <span class="subtitle-1">เพิ่มเทศกาล</span>
                      <v-icon color="#BA4438" @click.stop="dialogAddFes = false">close</v-icon>
                    </v-card-title>
                    <v-form ref="AddnewFes" v-model="valid" lazy-validation>
                      <v-card-text>
                        <v-container>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <p class="font-weight-bold mb-0">ชื่อเทศกาล</p>
                              <v-text-field
                                v-model="newfesname"
                                label="ชื่อเทศกาล"
                                flat
                                solo
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <DatePicker
                                ref="newFesStartDate"
                                v-model="newfesstdate"
                                @input="
                                  changeDate(
                                    utils.startDateChanged(newfesstdate, newfeseddate),
                                    false
                                  )
                                "
                              />
                            </v-col>
                            <v-col>
                              <DatePicker
                                ref="newFesEndDate"
                                v-model="newfeseddate"
                                @input="
                                  changeDate(
                                    utils.endDateChanged(newfesstdate, newfeseddate),
                                    false
                                  )
                                "
                              />
                            </v-col>
                          </v-row>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <p class="font-weight-bold mb-0">เทศกาลเปรียบเทียบ</p>
                              <v-select
                                v-model="newfescompare"
                                :items="[{ id: '', name: 'ไม่ได้เลือก' }].concat(festivalitem)"
                                item-text="name"
                                item-value="id"
                                no-data-text="ไม่ได้เลือก"
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions class="pa-5">
                        <div class="flex-grow-1"></div>
                        <v-btn
                          rounded
                          color="primary"
                          min-width="120px"
                          v-on="on"
                          class="ml-2"
                          @click="Addnewfestival()"
                          >บันทึก</v-btn
                        >
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item value="tabTrainSetting" class="px-5 pt-5">
            <v-row>
              <v-col cols="3" class="offset-md-9">
                <v-text-field
                  v-model="trainSearch"
                  append-icon="mdi-magnify"
                  label="ค้นหา"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-data-table
                  style="width: 100%"
                  :items-per-page="10"
                  loading-text="กำลังโหลดข้อมูล"
                  no-data-text="ไม่พบข้อมูล"
                  :items="trainsettingitems"
                  :landscape="true"
                  :headers="trainsettingheader"
                  :search="trainSearch"
                  class="TrainTable"
                >
                  <template v-slot:item="props">
                    <tr>
                      <td>{{ props.item.code || '-' }}</td>
                      <td>{{ props.item.start || '-' }}</td>
                      <td>{{ props.item.end || '-' }}</td>
                      <td>{{ props.item.start_time || '-' }}</td>
                      <td>{{ props.item.end_time || '-' }}</td>
                      <td>{{ props.item.line || '-' }}</td>
                      <td>{{ props.item.type || '-' }}</td>
                      <!-- <td>{{ props.item.up_down || '-' }}</td> -->
                      <td>
                        <v-btn
                          rounded
                          outlined
                          color="primary"
                          min-width="80px"
                          v-on="on"
                          @click.stop="$set(trainsettingdialog, props.item.index, true)"
                          >แก้ไข</v-btn
                        >
                        <v-dialog
                          v-model="trainsettingdialog[props.item.index]"
                          min-width="320px"
                          max-width="480px"
                        >
                          <v-card>
                            <v-card-title class="v-card-title">
                              <span class="subtitle-1">แก้ไขขบวนรถไฟ {{ props.item.code }}</span>
                              <v-icon
                                color="#BA4438"
                                @click.stop="$set(trainsettingdialog, props.item.index, false)"
                                >close</v-icon
                              >
                            </v-card-title>
                            <v-form ref="formTrainUpdate" v-model="valid" lazy-validation>
                              <v-card-text>
                                <v-container>
                                  <!-- code: ขบวนรถไฟ (int)
                                    start: สถานีเริ่มต้น (string from dropdown) → options/ref/railway_station
                                    start_time: เวลาเริ่มต้น (hh:mm)
                                    end: สถานีสิ้นสุด (string from dropdown) → options/ref/railway_station
                                    end_time: เวลาสิ้นสุด (hh:mm)
                                    line: สาย (autocomplete → เหนือ/ใต้/ตะวันออก/ตะวันออกเฉียงเหนือ (ไม่ dropdown เผื่ออยากกรอกอย่างอื่น))
                                    type: ประเภท (string ถ้าดึงอันที่มีมา autocomplete ได้เป็นดี)
                                    up_down: ขา (string from dropdown → ขึ้น/ล่อง) -->
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <p class="font-weight-bold mb-0">ขบวนรถไฟ</p>
                                      <v-text-field
                                        label="ขบวนรถไฟ"
                                        flat
                                        solo
                                        v-model="props.item.code"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <p class="font-weight-bold mb-0">สถานีเริ่มต้น</p>
                                      <v-autocomplete
                                        label="สถานีเริ่มต้น"
                                        flat
                                        solo
                                        :items="trainstationlist"
                                        :item-text="'name'"
                                        :item-value="'trainOptionvalue'"
                                        v-model="props.item.start"
                                      ></v-autocomplete>
                                    </v-col>
                                  </v-row>
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <p class="font-weight-bold mb-0">เวลาเริ่มต้น</p>
                                      <!-- <v-text-field
                                      label="เวลาเริ่มต้น"
                                      flat
                                      solo
                                      v-model="props.item.start_time" 
                                    ></v-text-field> -->
                                      <TimePicker
                                        v-model="props.item.start_time"
                                        :defaultTime="props.item.start_time"
                                      ></TimePicker>
                                    </v-col>
                                  </v-row>
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <p class="font-weight-bold mb-0">สถานีสิ้นสุด</p>
                                      <v-autocomplete
                                        label="สถานีสิ้นสุด"
                                        flat
                                        solo
                                        :items="trainstationlist"
                                        :item-text="'name'"
                                        :item-value="'trainOptionvalue'"
                                        v-model="props.item.end"
                                      ></v-autocomplete>
                                    </v-col>
                                  </v-row>
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <!-- <p class="font-weight-bold mb-0">เวลาสิ้นสุด</p>
                                    <v-text-field
                                      label="เวลาสิ้นสุด"
                                      flat
                                      solo
                                      v-model="props.item.end_time"
                                    ></v-text-field> -->
                                      <TimePicker
                                        v-model="props.item.end_time"
                                        :defaultTime="props.item.end_time"
                                      ></TimePicker>
                                    </v-col>
                                  </v-row>
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <p class="font-weight-bold mb-0">สายรถไฟ</p>
                                      <!-- <v-text-field
                                      label="สายรถไฟ"
                                      flat
                                      solo
                                      hide-no-data
                                      placeholder="เหนือ,ใต้,ตะวันออก,ตะวันออกเฉียงเหนือ"
                                      v-model="props.item.line"
                                    ></v-text-field> -->
                                      <v-select
                                        label="สายรถไฟ"
                                        flat
                                        solo
                                        :items="linelist"
                                        :item-text="'text'"
                                        :item-value="'value'"
                                        v-model="props.item.line"
                                      ></v-select>
                                    </v-col>
                                  </v-row>
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <p class="font-weight-bold mb-0">ประเภท</p>
                                      <!--<v-text-field
                                      label="ประเภท"
                                      flat
                                      solo
                                      hide-no-data
                                      v-model="props.item.type"
                                    ></v-text-field> -->
                                      <v-select
                                        label="ประเภท"
                                        flat
                                        solo
                                        :items="typelist"
                                        :item-text="'text'"
                                        :item-value="'value'"
                                        v-model="props.item.type"
                                      ></v-select>
                                    </v-col>
                                  </v-row>
                                  <v-row row wrap ma-4 mt-0>
                                    <v-col>
                                      <p class="font-weight-bold mb-0">ขา</p>
                                      <v-select
                                        label="ขา"
                                        flat
                                        solo
                                        :items="trainupdown"
                                        v-model="props.item.up_down"
                                      ></v-select>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                              <v-card-actions class="pa-5">
                                <div class="flex-grow-1"></div>
                                <v-btn
                                  rounded
                                  color="primary"
                                  min-width="120px"
                                  v-on="on"
                                  class="ml-2"
                                  @click="updateTrain(props.item)"
                                  >บันทึก</v-btn
                                >
                              </v-card-actions>
                            </v-form>
                          </v-card>
                        </v-dialog>
                      </td>
                      <td>
                        <v-btn
                          rounded
                          outlined
                          color="primary"
                          min-width="80px"
                          v-on="on"
                          @click="
                            traindeletealertdialog = true;
                            traintarget = props.item;
                          "
                          >ลบ</v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-btn
                  :block="$vuetify.breakpoint.xsOnly"
                  rounded
                  width="120"
                  color="primary"
                  class="mt-2 ml-2"
                  @click.stop="dialogAddTrain = true"
                  >เพิ่ม</v-btn
                >
                <v-dialog v-model="dialogAddTrain" min-width="320px" max-width="480px">
                  <v-card>
                    <v-card-title class="v-card-title">
                      <span class="subtitle-1">เพิ่มขบวนรถไฟ</span>
                      <v-icon color="#BA4438" @click.stop="dialogAddTrain = false">close</v-icon>
                    </v-card-title>
                    <v-form ref="formTrainUpdate" v-model="valid" lazy-validation>
                      <v-card-text>
                        <v-container>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <p class="font-weight-bold mb-0">ขบวนรถไฟ</p>
                              <v-text-field
                                label="ขบวนรถไฟ"
                                flat
                                solo
                                v-model="newtrain.code"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <p class="font-weight-bold mb-0">สถานีเริ่มต้น</p>
                              <v-autocomplete
                                label="สถานีเริ่มต้น"
                                flat
                                solo
                                :items="trainstationlist"
                                :item-text="'name'"
                                :item-value="'trainOptionvalue'"
                                v-model="newtrain.start"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <p class="font-weight-bold mb-0">เวลาเริ่มต้น</p>
                              <!-- <v-text-field
                                label="เวลาเริ่มต้น"
                                flat
                                solo
                                v-model="newtrain.start_time"
                              ></v-text-field> -->
                              <TimePicker v-model="newtrain.start_time"></TimePicker>
                            </v-col>
                          </v-row>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <p class="font-weight-bold mb-0">สถานีสิ้นสุด</p>
                              <v-autocomplete
                                label="สถานีสิ้นสุด"
                                flat
                                solo
                                :items="trainstationlist"
                                :item-text="'name'"
                                :item-value="'trainOptionvalue'"
                                v-model="newtrain.end"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <p class="font-weight-bold mb-0">เวลาสิ้นสุด</p>
                              <!-- <v-text-field
                                label="เวลาสิ้นสุด"
                                flat
                                solo
                                v-model="newtrain.end_time"
                              ></v-text-field> -->
                              <TimePicker v-model="newtrain.end_time"></TimePicker>
                            </v-col>
                          </v-row>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <p class="font-weight-bold mb-0">สายรถไฟ</p>
                              <!-- <v-text-field
                                label="สายรถไฟ"
                                flat
                                solo
                                hide-no-data
                                placeholder="เหนือ,ใต้,ตะวันออก,ตะวันออกเฉียงเหนือ"
                                v-model="newtrain.line"
                              ></v-text-field> -->
                              <v-select
                                label="สายรถไฟ"
                                flat
                                solo
                                :items="linelist"
                                :item-text="'text'"
                                :item-value="'value'"
                                v-model="newtrain.line"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <p class="font-weight-bold mb-0">ประเภท</p>
                              <!-- <v-text-field
                                label="ประเภท"
                                flat
                                solo
                                hide-no-data
                                v-model="newtrain.type"
                              ></v-text-field> -->
                              <v-select
                                label="ประเภท"
                                flat
                                solo
                                :items="typelist"
                                :item-text="'text'"
                                :item-value="'value'"
                                v-model="newtrain.type"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row row wrap ma-4 mt-0>
                            <v-col>
                              <p class="font-weight-bold mb-0">ขา</p>
                              <v-select
                                label="ขา"
                                flat
                                solo
                                :items="trainupdown"
                                v-model="newtrain.up_down"
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions class="pa-5">
                        <div class="flex-grow-1"></div>
                        <v-btn
                          rounded
                          color="primary"
                          min-width="120px"
                          v-on="on"
                          class="ml-2"
                          @click.stop="Addnewtrain"
                          >บันทึก</v-btn
                        >
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- <v-tab-item
            value="tabCitizen"
            class="px-5 pt-5"
          >
            <v-layout
              row
              wrap
              ma-0
            >
              aaaassss
            </v-layout>
          </v-tab-item>-->
        </v-tabs>
      </div>
    </v-flex>
    <v-flex>
      <AlertDialog
        v-model="fesdeletealertdialog"
        status="error"
        :cancelBtn="true"
        @cancel-btn-click="fesdeletealertdialog = false"
        @ok-btn-click="
          festivalDelete();
          fesdeletealertdialog = false;
        "
        >ต้องการลบข้อมูลใช่หรือไม่</AlertDialog
      >
      <AlertDialog
        v-model="traindeletealertdialog"
        status="error"
        :cancelBtn="true"
        @cancel-btn-click="traindeletealertdialog = false"
        @ok-btn-click="
          deleteTrain();
          traindeletealertdialog = false;
        "
        >ต้องการลบข้อมูลใช่หรือไม่</AlertDialog
      >
      <AlertDialog v-model="successdialog" status="success" @ok-btn-click="successdialog = false"
        >แก้ไขข้อมูลสำเร็จ</AlertDialog
      >
      <AlertDialog
        v-model="faildialog"
        status="error"
        @ok-btn-click="
          faildialog = false;
          errorMessage = null;
        "
        >{{ errorMessage || 'ดำเนินการไม่สำเร็จ' }}</AlertDialog
      >
    </v-flex>
  </v-layout>
</template>

<script>
import DatePicker from '../global/DatePicker';
import TimePicker from '../global/TimePicker';
import AlertDialog from '../global/AlertDialog';

const qs = require('qs');

export default {
  name: 'UserManagement',
  components: {
    DatePicker,
    TimePicker,
    AlertDialog
  },
  data: () => ({
    successdialog: false,
    faildialog: false,
    errorMessage: null,
    footerProps: {
      itemsPerPageOptions: [],
      itemsPerPageText: 'จำนวนแถวที่แสดง',
      disableItemsPerPage: true
    },
    fesdeletealertdialog: false,
    traindeletealertdialog: false,
    searchType: '',
    userItems: [],
    roleItems: [],
    on: false,
    dialogAddUser: false,
    dialogAddFes: false,
    dialogEditUser: {},
    dialogEditFes: {},
    dialogAddTrain: false,
    trainSearch: '',
    newtrain: {
      code: '',
      start: '',
      end: '',
      start_time: '',
      end_time: '',
      line: '',
      type: '',
      up_down: ''
    },
    confirmDialog: {},
    userAdd: {
      email: '',
      fullname: '',
      username: '',
      password: '',
      confirm_password: '',
      role: ''
      // enabled: false,
    },
    traintarget: '',
    festarget: '',
    newfesstdate: '',
    newfeseddate: '',
    newfesname: '',
    newfescompare: '',
    usernameRules: [
      v => !!v || 'Username is required',
      v => (v || '').indexOf(' ') < 0 || 'No spaces are allowed'
    ],
    passwordRules: [v => !!v || 'Password is required'],
    confirmPasswordRules: {
      check(password, confirmPassword) {
        if (!password) return 'Password is required';
        if (!confirmPassword) return 'Confirmation password is required';
        if (password !== confirmPassword) return 'Password must match';
        return true;
      }
    },
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ],
    roleRules: [v => !!v || 'Role is required'],
    valid: true,
    userHeader: [
      {
        text: 'ลำดับ',
        value: 'id',
        align: 'center',
        sortable: true
      },
      {
        text: 'ชื่อผู้ใช้',
        value: 'username',
        align: 'center',
        sortable: true
      },
      {
        text: 'อีเมล',
        value: 'email',
        align: 'center',
        sortable: true
      },
      {
        text: 'ตำแหน่ง',
        value: 'role',
        align: 'center',
        sortable: true
      },
      {
        text: 'เชื่อมต่อครั้งล่าสุด',
        value: 'lastLogin',
        align: 'center',
        sortable: true
      },
      {
        text: '',
        value: '',
        sortable: false
      }
    ],
    festivalheader: [
      {
        text: 'ค่าเริ่มต้น',
        value: 'isdefault',
        align: 'center',
        sortable: false
      },
      {
        text: 'ชื่อเทศกาล',
        value: 'name',
        align: 'center'
      },
      {
        text: 'วันที่เริ่มต้น',
        value: 'start_date',
        align: 'center'
      },
      {
        text: 'วันที่สิ้นสุด',
        value: 'end_date',
        align: 'center'
      },
      {
        text: '',
        sortable: false
      },
      {
        text: '',
        sortable: false
      }
    ],
    festivalitem: [],
    festivalSelected: [],
    trainstationlist: [],
    trianlineItems: [
      {
        text: 'เหนือ',
        value: 'เหนือ'
      },
      {
        text: 'ใต้',
        value: 'ใต้'
      },
      {
        text: 'ตะวันออก',
        value: 'ตะวันออก'
      },
      {
        text: 'ตะวันออกเฉียงเหนือ',
        value: 'ตะวันออกเฉียงเหนือ'
      }
    ],
    linelist: [
      {
        text: 'ใต้',
        value: 'ใต้'
      },
      {
        text: 'เหนือ',
        value: 'เหนือ'
      },
      {
        text: 'ตะวันออกเฉียงเหนือ',
        value: 'ตะวันออกเฉียงเหนือ'
      },
      {
        text: 'ตะวันออก',
        value: 'ตะวันออก'
      },
      {
        text: 'แม่กลอง',
        value: 'แม่กลอง'
      }
    ],
    typelist: [
      {
        text: 'รถท้องถิ่น',
        value: 'รถท้องถิ่น'
      },
      {
        text: 'รถชานเมือง',
        value: 'รถชานเมือง'
      },
      {
        text: 'ด่วนพิเศษอุตราวิถี',
        value: 'ด่วนพิเศษอุตราวิถี'
      },
      {
        text: 'ด่วนพิเศษอีสานวัตนา',
        value: 'ด่วนพิเศษอีสานวัตนา'
      },
      {
        text: 'ด่วนพิเศษอีสานมรรคา',
        value: 'ด่วนพิเศษอีสานมรรคา'
      },
      {
        text: 'สินค้าประจำ',
        value: 'สินค้าประจำ'
      },
      {
        text: 'พิเศษโดยสาร',
        value: 'พิเศษโดยสาร'
      },
      {
        text: 'พิเศษโดยสารเปล่า',
        value: 'พิเศษโดยสารเปล่า'
      },
      {
        text: 'สินค้าเมื่อต้องการ',
        value: 'สินค้าเมื่อต้องการ'
      },
      {
        text: 'รถด่วนพิเศษ',
        value: 'รถด่วนพิเศษ'
      },
      {
        text: 'รถด่วน',
        value: 'รถด่วน'
      },
      {
        text: 'รถเร็ว',
        value: 'รถเร็ว'
      },
      {
        text: 'รถธรรมดา',
        value: 'รถธรรมดา'
      },
      {
        text: 'รถท่องเที่ยว',
        value: 'รถท่องเที่ยว'
      },
      {
        text: 'รถขนส่งสินค้า',
        value: 'รถขนส่งสินค้า'
      },
      {
        text: 'รถพิเศษช่วยการโดยสาร',
        value: 'รถพิเศษช่วยการโดยสาร'
      },
      {
        text: 'รถเสริมช่วงเทศกาล',
        value: 'รถเสริมช่วงเทศกาล'
      }
    ],
    trainsettingheader: [
      {
        text: 'ขบวนรถ',
        value: 'code',
        align: 'center',
        sortable: true
      },
      {
        text: 'สถานีเริ่มต้น',
        value: 'start',
        align: 'center',
        sortable: true
      },
      {
        text: 'สถานีปลายทาง',
        value: 'end',
        align: 'center',
        sortable: true
      },
      {
        text: 'เวลาออกเดินทาง',
        value: 'start_time',
        align: 'center',
        sortable: true
      },
      {
        text: 'เวลาถึงปลายทาง',
        value: 'end_time',
        align: 'center',
        sortable: true
      },
      {
        text: 'สายรถไฟ',
        value: 'line',
        align: 'center',
        sortable: true
      },
      {
        text: 'ประเภทของรถไฟ',
        value: 'type',
        align: 'center  ',
        sortable: true
      },
      // {
      //   text: 'ขึ้น-ล่อง',
      //   value: 'trainupdown',
      //   align: 'center',
      //   sortable: false
      // },
      {
        text: '',
        sortable: false
      },
      {
        text: '',
        sortable: false
      }
    ],
    trainsettingitems: [],
    trainupdown: [
      {
        text: 'ขึ้น',
        value: 'ขึ้น'
      },
      {
        text: 'ล่อง',
        value: 'ล่อง'
      }
    ],
    trainsettingdialog: {},
    today: null,
    userLoginRole: localStorage.getItem('role')
  }),
  created() {
    this.getRoleLists();
    this.getUsers();
  },
  mounted() {
    this.today = this.utils.getLocalDate();
    this.init();
  },
  methods: {
    init() {
      if (this.userLoginRole === 'SRT_ADMIN') {
        this.serchType = 'tabTrainSetting';
      }
      this.getFestival();
      this.gettrainlist();
      this.gettrainstaionlist();
    },
    gettrainlist() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/train_line`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            scope.trainsettingitems = data;
            for (let index = 0; index < scope.trainsettingitems.length; index++) {
              const element = scope.trainsettingitems[index];
              element.index = index;
            }
          }
        })
        .catch(error => {
          scope.roleItems = [];
          const { response } = error;
          if (response.status === 401) {
            console.log('unauthorized');
            scope.$router.push({ name: 'unauthorized' });
          } else {
            console.log(error);
          }
        });
    },
    gettrainstaionlist() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/railway_station`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            scope.trainstationlist = data;
            scope.trainstationlist.forEach(element => {
              return (element.trainOptionvalue = element.name
                .replace('สถานีรถไฟ', '')
                .replace('ชุมทาง', 'ชท.')
                .replace(' (หัวลำโพง)', '')); // hard code
            });
          }
        })
        .catch(error => {
          scope.roleItems = [];
          console.log(error);
        });
    },
    isTraincodeExist(code) {
      if (this.trainsettingitems.find(member => member.code === code)) this.isCanSavetrain = false;
      else this.isCanSavetrain = true;
    },
    setFesDefault(item) {
      for (let index = 0; index < this.festivalitem.length; index += 1) {
        const element = this.festivalitem[index];
        if (element.id === item.id) {
          element.isdefault = true;
          this.updateFes(item);
        } else element.isdefault = false;
      }
    },
    updateRadio() {
      this.festivalSelected = null;
      setTimeout(() => {
        const fest = this.festivalitem.filter(item => item.isdefault);
        this.festivalSelected = fest[0].id;
      }, 500);
    },
    getRoleLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/api/roles`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            scope.roleItems = data;
          }
        })
        .catch(error => {
          scope.roleItems = [];
          console.log(error);
        });
    },
    getFestival() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival`;
      const scope = this;
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            const { data } = response.data;
            for (let index = 0; index < data.length; index += 1) {
              const element = data[index];
              element.start_date = element.start_date.substr(0, 10);
              element.end_date = element.end_date.substr(0, 10);
            }
            scope.festivalitem = data;
            // this.festivalSelected = data.filter(member => {
            //   return member.isdefault;
            // })[0].id;
            const defaultFes = data.filter(member => {
              return member.isdefault;
            })[0];
            if (defaultFes) scope.festivalSelected = defaultFes.id;
          }
        })
        .catch(error => {
          scope.festivalitem = [];
          console.error(error);
        });
    },
    updateFes(item) {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/update/festival`;
      const scope = this;
      this.axios.post(url, qs.stringify(item)).then(response => {
        if (response.status == 200) {
          scope.successdialog = true;
        } else {
          scope.faildialog = true;
          console.error(response);
        }
      });
    },
    updateTrain(item) {
      const finddup = this.trainsettingitems.find(
        member => member.code === item.code && member.index !== item.index
      );
      if (finddup) {
        this.errorMessage = 'รหัสขบวนรถไฟนี้มีอยู่แล้ว';
        this.faildialog = true;
      } else {
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/update/train_line`;
        const scope = this;
        this.axios
          .post(
            url,
            qs.stringify({
              code: item.code,
              start: item.start,
              end: item.end,
              start_time: item.start_time,
              end_time: item.end_time,
              line: item.line,
              type: item.type,
              up_down: item.up_down
            })
          )
          .then(response => {
            if (response.status == 200) {
              scope.successdialog = true;
              scope.$set(scope.trainsettingdialog, item.index, false);
            } else {
              scope.faildialog = true;
              this.errorMessage = response.data ? response.data.message : null;
              console.error(response);
            }
          });
      }
    },
    getUsers() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/api/users`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            scope.userItems = data;
            scope.userItems = scope.userItems.map(item => {
              item.old_role = item.role_code;
              return item;
            });
          }
        })
        .catch(error => {
          scope.userItems = [];
          const { response } = error;
          if (response.status === 401 || response.status === 403) {
            console.log('unauthorized');
            scope.$router.push({ name: 'unauthorized' });
          } else {
            console.log(error);
          }
        });
    },
    close() {},
    submitRegister() {
      if (!this.$refs.formRegister.validate()) return;
      this.register();
    },
    register() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/authen/register`;
      const scope = this;

      if (this.userItems.some(item => item.username == this.userAdd.username)) {
        this.faildialog = true;
        this.errorMessage = 'มีชื่อผู้ใช้นี้แล้ว';
        return;
      }
      const passw = /^(?=.*\d)(?=.*[a-z]).{8,20}$/;
      if(!scope.userAdd.password.match(passw)) {
        this.faildialog = true;
        this.errorMessage = 'กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวอักษรภาษาอังกฤษและตัวเลข';
        return;
      }

      const data = {
        username: scope.userAdd.username,
        password: scope.userAdd.password,
        fullname: scope.userAdd.fullname,
        email: scope.userAdd.email,
        role: scope.userAdd.role,
        access_token: localStorage.access_token
      };

      this.axios
        .post(url, qs.stringify(data))
        .then(response => {
          if (response.status == 200) {
            scope.successdialog = true;
            scope.userAdd = {
              email: '',
              username: '',
              password: '',
              fullname: '',
              confirm_password: '',
              role: ''
              // enabled: false,
            };
            this.dialogAddUser = false;
            scope.getUsers();
          }
        })
        .catch(error => {
          scope.faildialog = true;
          console.log(error);
        });
    },
    deleteTrain() {
      if (this.traintarget) {
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/delete/train_line`;
        const scope = this;
        this.axios.post(url, qs.stringify({ code: this.traintarget.code })).then(response => {
          if (response.status === 200) {
            scope.trainsettingitems = this.trainsettingitems.filter(
              train => train.code !== scope.traintarget.code
            );
            scope.successdialog = true;
          } else {
            scope.faildialog = true;
          }
        });
      }
    },
    festivalDelete() {
      if (!this.festarget.isdefault) {
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/delete/festival`;
        const scope = this;
        this.axios.post(url, qs.stringify({ id: this.festarget.id })).then(response => {
          if (response.status === 200) {
            scope.festivalitem = scope.festivalitem.filter(fes => fes.id !== scope.festarget.id);
            scope.successdialog = true;
          } else {
            scope.faildialog = true;
          }
        });
      } else {
        this.errorMessage = 'ไม่สามารถลบเทศการที่เป็นค่าเริ่มต้นได้';
        this.faildialog = true;
      }
    },
    Addnewfestival() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/update/festival`;
      const scope = this;
      this.axios
        .post(
          url,
          qs.stringify({
            name: this.newfesname,
            start_date: this.newfesstdate,
            end_date: this.newfeseddate,
            compare_id: this.newfescompare,
            isdefault: false
          })
        )
        .then(response => {
          if (response.status == 200) {
            const newid = response.data.data.id;
            scope.festivalitem.push({
              id: newid,
              name: scope.newfesname,
              start_date: scope.newfesstdate,
              end_date: scope.newfeseddate,
              compare: scope.newfescompare
            });
            scope.successdialog = true;
          } else {
            scope.faildialog = true;
            console.error(response);
          }
        });

      this.dialogAddFes = false;
    },
    Addnewtrain() {
      if (this.trainsettingitems.find(member => member.code === this.newtrain.code)) {
        this.errorMessage = 'รหัสขบวนรถไฟนี้มีอยู่แล้ว';
        this.faildialog = true;
      } else {
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/update/train_line`;
        const scope = this;
        this.axios
          .post(url, qs.stringify(this.newtrain))
          .then(response => {
            if (response.status == 200) {
              // this.newtrain.code = response.data.data.id;
              scope.newtrain.index = scope.trainsettingitems.length;
              scope.trainsettingitems.push(scope.newtrain);
              scope.successdialog = true;
              scope.newtrain = {
                code: '',
                start: '',
                end: '',
                start_time: '',
                end_time: '',
                line: '',
                type: '',
                up_down: ''
              };
            }
          })
          .catch(response => {
            this.errorMessage = response.response.data ? response.response.data.message : null;
            this.faildialog = true;
          });
        this.dialogAddTrain = false;
      }
    },
    submitUpdate(user) {
      if (!this.$refs.formUpdate.validate()) return;
      this.update(user);
    },
    update(user) {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/authen/update`;
      const scope = this;
      const passw = /^(?=.*\d)(?=.*[a-z]).{8,20}$/;
      if(!user.password.match(passw)) {
        this.faildialog = true;
        this.errorMessage = 'กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวอักษรภาษาอังกฤษและตัวเลข';
        return;
      }

      const data = {
        username: user.username,
        password: user.password,
        fullname: user.fullname,
        email: user.email,
        old_role: user.old_role,
        new_role: user.role_code,
        enabled: user.enabled,
        access_token: localStorage.access_token
      };

      this.axios
        .post(url, qs.stringify(data))
        .then(response => {
          if (response.status == 200) {
            scope.successdialog = true;
            scope.dialogEditUser = {};
            scope.getUsers();
          }
        })
        .catch(function(error) {
          scope.faildialog = true;
          console.log(error);
        });
    },
    openConfirmDialog(id) {
      this.dialogEditUser = {};
      this.confirmDialog[id] = true;
    },
    cancelDeleteUser() {
      this.confirmDialog = {};
    },
    confirmDeleteUser(user) {
      this.confirmDialog = {};
      this.deleteUser(user);
    },
    deleteUser(user) {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/authen/delete`;
      const scope = this;

      const data = {
        username: user,
        access_token: localStorage.access_token
      };

      this.axios
        .post(url, qs.stringify(data))
        .then(response => {
          if (response.status == 200) {
            scope.successdialog = true;
            scope.getUsers();
          }
        })
        .catch(function(error) {
          scope.faildialog = true;
          console.log(error);
        });
    },
    changeDate(period, editId) {
      if (period) {
        if (editId) {
          const fest = this.festivalitem.filter(item => item.id == editId);
          if (period.startDate != fest[0].start_date) {
            this.$refs.editFesStartDate.setDefaultData(period.startDate);
          }
          if (period.endDate != fest[0].end_date) {
            this.$refs.editFesEndDate.setDefaultData(period.endDate);
          }
        } else {
          if (period.startDate != this.newfesstdate) {
            this.$refs.newFesStartDate.setDefaultData(period.startDate);
          }
          if (period.endDate != this.newfeseddate) {
            this.$refs.newFesEndDate.setDefaultData(period.endDate);
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.v-tab.v-tab--active {
  border-bottom: 1px solid #ba4438;
}

.card-border {
  margin-top: 4px;
  overflow: hidden;
}

.card-border.error--text {
  overflow: inherit !important;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}

.v-text-field {
  height: 40px;
}

.headline {
  color: #ba4438;
  border-bottom: 1px solid #ededed;
  p {
    font-size: 18px;
  }
}

.v-card-title {
  border-bottom: 1px solid #cfcfcf;
  justify-content: space-between;
}

.v-card__text {
  padding: 12px 20px 0 20px !important;
}

.v-expansion-panel {
  margin-bottom: 18px;
  border: 1px solid #cfcfcf;
  border-radius: 5px;
}

.v-expansion-panel-header {
  padding: 5px 10px;
  min-height: 40px !important;
  background: #efefef;
}

.v-expansion-panel-content {
  padding: 10px 0 0 0;
}

.v-text-field {
  height: 40px;
}

.inactive-user {
  color: #888;
}
</style>
